import ApiSuffix from './ApiSuffix';
import BaseUrl from './BaseUrl';
import getAuthToken from './AuthToken';

// window.LoyaloopNative is injected by the Loyaloop Alert Android app; it is
// undefined in a normal browser, so everything here is a no-op on the web.
export const isNativeApp = () => !!window.LoyaloopNative;

let syncInFlight = null;

// Sends this device's FCM token to the backend so the logged-in outlet's
// payment alerts reach it. Skips the call when the backend already has this
// token, unless `force` is set (login, where the outlet's auth token is new).
export const syncOutletFcmToken = ({ force = false } = {}) => {
  if (!isNativeApp() || localStorage.getItem('loginType') !== 'outlet') return Promise.resolve();
  if (syncInFlight && !force) return syncInFlight;

  syncInFlight = sendTokenToBackend(force)
    .catch((error) => console.warn('FCM token sync failed', error))
    .finally(() => {
      syncInFlight = null;
    });

  return syncInFlight;
};

const sendTokenToBackend = async (force) => {
  const authToken = getAuthToken();
  const xApiKey = localStorage.getItem('X-API-KEY');
  if (!authToken || !xApiKey) {
    console.warn('FCM token sync skipped: missing auth token or X-API-KEY');
    return;
  }

  const native = window.LoyaloopNative;
  const fcmToken = await native.getFcmToken();
  if (!fcmToken) return;

  // The app keeps this outside localStorage, which logout clears.
  const registeredToken = await native.getRegisteredFcmToken();
  if (!force && registeredToken === fcmToken) {
    console.log('FCM token already registered, skipping API call');
    return;
  }

  console.log('Registering FCM token with backend', force ? '(login)' : '(token changed)');
  const response = await fetch(BaseUrl.dev + ApiSuffix.updateOutletFcmToken, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: authToken,
      'X-API-KEY': xApiKey,
    },
    body: JSON.stringify({ fcm_token: fcmToken }),
  });
  const data = await response.json().catch(() => ({}));

  if (!response.ok || data.error === true) {
    throw new Error(data.error_msg || `update-outlet-fcm-token failed (${response.status})`);
  }

  await native.setRegisteredFcmToken(fcmToken);
  console.log('FCM token registered');
};
